import { route } from 'quasar/wrappers';
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
import routes from 'src/router/routes';
import {MetaRouter} from 'src/models/router';
import {useAuthStore} from 'src/stores/auth/useAuthStore';
import { storeToRefs } from 'pinia'
import {useCancelRequestTokenStore} from 'src/stores/axios/useCancelRequestTokenStore';
import {useAuth} from 'src/services/domains/auth/useAuth';
import {can, canTo} from 'src/services/utils/common';
import {pushNotify} from 'src/helpers/notify';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route<{example: unknown}>(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
    ? createWebHistory
    : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(
      process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE
    ),
  });

  Router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore();
    const {isAuthenticated} = storeToRefs(authStore);

    if (to.name !== from.name) useCancelRequestTokenStore().cancelRequests();
    await useAuth().authCheck();

    if (to.matched.some((r: MetaRouter) => !!r.meta.auth) && !isAuthenticated.value) {
      return next({name: 'Login'});
    }
    else if (to.matched.some((r: MetaRouter) => !!r.meta.guess) && isAuthenticated.value) {
      return next({name: 'Index'});
    }
    else if (to.matched.some((r: MetaRouter) => !!r.meta.permissions && !can(r.meta.permissions))) {
      pushNotify('danger', 'Bạn không có quyền truy cập');
      return next({name: from.name || 'Index'});
    }

    if (to.name === 'Index') {
      if (canTo('ConsultantDashboard')) {
        return next({name: 'ConsultantDashboard'});
      }
      else if (canTo('CustomerManagementDashboard')) {
        return next({name: 'CustomerManagementDashboard'});
      }
      else if (canTo('FinanceDashboard')) {
        return next({name: 'FinanceDashboard'});
      }
    }

    return next();
  });

  return Router;
});
